<template>
  <div class="p-4" v-if="showForm">
    {{ titleForm }}
    <br />
    <br />
    <BaseForm
      :formElements="formElements"
      @form:onSubmit="value => saveStudy(value)"
      :isLoading="isLoading"
    >
      <template #elements>
        <BaseFormElement
          :key="key"
          v-for="(element, key) in formElements"
          :elements="formElements"
          :element="element"
          v-model="element.data.value"
        >
          <template #after>
            <component :is="element.after" />
          </template>
        </BaseFormElement>
      </template>
    </BaseForm>
  </div>

  <div v-else>
    Loading
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import BaseForm from '@/components/form/BaseForm.vue'
import BaseFormElement from '@/components/form/BaseFormElement.vue'
import { formElements as ExperienceFormElements } from '@/config/ExperienceFormElements.ts'
import syncValues from '@/utils/syncValues.ts'

// Experience store
import { EXPERIENCES_STORE_NAME } from '@/store/modules/experiences'
import {
  CREATE_EXPERIENCE,
  UPDATE_EXPERIENCE
} from '@/store/modules/experiences/actions.type'

// Notifications store
import { NOTIFICATIONS_STORE_NAME } from '@/store/modules/notifications'
import { PUSH_NOTIFICATION } from '@/store/modules/notifications/actions.type'

export default {
  components: { BaseForm, BaseFormElement },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()
    const experiences = computed(
      () => store.getters[EXPERIENCES_STORE_NAME + '/data']
    )
    const formElements = ref(ExperienceFormElements())

    const isNewExperience = computed(() => props.id === null)
    const titleForm = computed(() =>
      isNewExperience.value ? 'Nueva experiencia' : 'Editar experiencia'
    )
    const existExperience = computed(() => experiences?.value?.[props.id])
    const showForm = computed(
      () => isNewExperience.value || existExperience.value
    )

    const isLoading = computed(
      () => store.getters[EXPERIENCES_STORE_NAME + '/isLoading']
    )
    const isError = computed(
      () => store.getters[EXPERIENCES_STORE_NAME + '/isError']
    )
    const isReady = computed(
      () => store.getters[EXPERIENCES_STORE_NAME + '/isReady']
    )

    async function saveStudy(data) {
      if (props.id) {
        data.id = props.id
      }
      const action = isNewExperience.value
        ? CREATE_EXPERIENCE
        : UPDATE_EXPERIENCE
      await store.dispatch(EXPERIENCES_STORE_NAME + '/' + action, data)
      if (isReady.value) {
        router.push({ name: 'experiences' })

        pushNotification({
          title: isNewExperience.value
            ? 'Creado'
            : 'Actualizado' + ' correctamente!',
          desciption: 'Tu experiencia se ha guardado correctamente ',
          type: 'success'
        })
      }
      if (isError.value) {
        pushNotification({
          title: 'Algun error ha ocurrido!',
          desciption: 'Vuelve a intentarlo o contacta a soporte',
          type: 'error'
        })
      }
    }

    function pushNotification(data) {
      store.dispatch(NOTIFICATIONS_STORE_NAME + '/' + PUSH_NOTIFICATION, data)
    }

    watch(experiences, value => {
      if (value && props.id) {
        if (!existExperience.value) {
          router.push({ name: 'courses' })
        }
        if (existExperience.value) {
          formElements.value = syncValues(
            formElements.value,
            existExperience.value
          )
        }
      }
    })

    if (existExperience.value) {
      formElements.value = syncValues(formElements.value, existExperience.value)
    }

    return { formElements, isLoading, saveStudy, titleForm, showForm }
  }
}
</script>
